module.exports = __webpack_public_path__ + "static/media/BS_F_Timeless_Sforza_White.c26d4620.png";